import {getUserConfig, getWeekDay} from "@utility/utils";

const data = getWeekDay(0)

const initialState = {
    list: [],
    total: 0,
    loading: false,
    searching: false,
    submitting: false,
    searchParams: {
        refresh: false,
        status: "",
        operatorID: "",
        club_id: "",
        start_date: data[0],
        end_date: data[1],
        page: 1,
        count: 30,
        ...getUserConfig("clubActivityData")
    }
}

const activityReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'CLUB_ACTIVITY_DATA':
            return {
                ...state,
                ...action.payload
            }
        case 'CLUB_ACTIVITY_DATA_RELOAD':
            return {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    refresh: true
                }
            }
        case 'CLUB_ACTIVITY_DATA_INIT':
            return {
                ...initialState,
                searchParams: {
                    ...initialState.searchParams,
                    ...getUserConfig("clubActivityData")
                }
            }
        default:
            return {...state};
    }
}

export default activityReducer
